import { defineMessages } from 'react-intl';

export const messages: {
	timePlaceholder: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	timePlaceholder: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.local-time-input.edit.time-placeholder',
		description: 'Placeholder for the local time input field when no time is selected',
		defaultMessage: 'e.g. {time}',
	},
});
